export const locations = () => {
    const locationButtons = document.querySelectorAll('.location-link');
    const locationDisplay = document.querySelectorAll('.location-overview');

    for (let j = 0; j < locationButtons.length; j += 1) {
        locationButtons[j].addEventListener('click', () => {
            for (let i = 0; i < locationButtons.length; i += 1) {
                locationButtons[i].classList.remove('button-highlighted');
                locationDisplay[i].classList.remove(
                    'displayed-location-overview'
                );
            }
            locationButtons[j].classList.add('button-highlighted');
            locationDisplay[j].classList.add('displayed-location-overview');
        });
    }
};
